import { Loader, useTheme, Grid, Tabs } from '@aws-amplify/ui-react';
import HomePageCurrentUser from './HomePageCurrentUser.js';
import UploadPage from './upload/UploadPage';
import React, { useState, useEffect } from 'react';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';


function HomePage(props) {

    const navigate = useNavigate();
    const handleAdminPage = () => {
        navigate("/admin")
      }
    const { tokens } = useTheme();
    const [isTemporal, setIsTemporal] = useState(true);
    const [temporalComponent, setTemporalComponent] = useState();

    const handlerOnIdle = () => {
        alert('Fuiste deslogueado por inactividad de 5 minutos.')
        signOut({ global: true }).then(console.log)
    }

    useIdleTimer({
        timeout: 1000 * 60 * 5, //5 minutos de inactividad
        onIdle: handlerOnIdle,
        debounce: 500,
    })

    const handlerLoader = () => {
        const loaderTimeout = setTimeout(() => {
            setIsTemporal(false);
        }, 3000);

        setTemporalComponent(
            <Loader
                variation="linear"
                emptyColor={tokens.colors.gray}
                filledColor={'#588292'}
            />)
    }

    useEffect(() => {
        handlerTemporal("loader");
        return;
    }, []);

    const handlerTemporal = (type) => {
        if (type === 'loader') {
            handlerLoader();
        }
    }

    return (
        <div className="container">
            {isTemporal ? (
                <div className="container">
                    <Grid
                        templateColumns="10fr"
                        templateRows="10rem"
                    >
                        <div>
                            <h3>Hola, {props.userName}, bienvenido a</h3>
                            <h1>
                                DATA LOADER
                            </h1>

                        </div>
                        {temporalComponent}
                    </Grid></div>) : (
                <>

                    <Tabs
                        spacing="relative"
                        justifyContent="flex-start"
                        defaultValue='1'
                        items={[
                            { label: 'Proyectos Asignados', value: '1', content: <HomePageCurrentUser username={props.userName} role={props.role}/> },
                            { label: 'Cargar', value: '2', content: <UploadPage isAdmin={props.isAdmin} role={props.role}/> }
                        ]}
                    />
                </>
            )}
        </div>

    )
}

export default HomePage;